import type { Config } from "tailwindcss"

export const PRIMARY = {
  DEFAULT: "#FFFFFF",
  50: "#FFFFFF",
  100: "#D0D1D4",
  200: "#A1A3A9",
  300: "#73747F",
  400: "#444654",
  500: "#151829",
  600: "#111321",
  700: "#0B0414",
}

export const SECONDARY = {
  DEFAULT: "#FFFFFF",
  50: "#FFFFFF",
  100: "#D6B8FC",
  200: "#B580F5",
  300: "#9854EB",
  400: "#8036DB",
  500: "#6B21C4",
  600: "#5715A7",
  700: "#440E87",
}

export const SUCCESS = {
  DEFAULT: "#FFFFFF",
  50: "#FFFFFF",
  100: "#B8FCF0",
  200: "#80F5E2",
  300: "#54EBD2",
  400: "#36DBBF",
  500: "#0ECFAE",
  600: "#15A78F",
  700: "#022C25",
}

export const ERROR = {
  DEFAULT: "#BE2932",
  50: "#FFFFFF",
  100: "#FCB8BC",
  200: "#F58088",
  300: "#EB545E",
  400: "#DB3641",
  500: "#BE2932",
  600: "#A7152D",
  700: "#580614",
}

export const STATE_VISITED = {
  DEFAULT: "#5656EB",
  50: "#5656EB",
  100: "#4141CE",
  200: "#2E2E91",
}

export const STATE_BONUS = {
  DEFAULT: "#FEA566",
  50: "#FEA566",
  100: "#EB9152",
  200: "#8C532B",
}

// Colors below are not from figma color pallete
export const WARNING = {
  DEFAULT: "#DC6803",
  25: "#FFFCF5",
  50: "#FFFAEB",
  100: "#FEF0C7",
  200: "#FEDF89",
  300: "#FEC84B",
  400: "#FDB022",
  500: "#F79009",
  600: "#DC6803",
  700: "#B54708",
  800: "#93370D",
  900: "#7A2E0E",
}

export const GRAY = {
  DEFAULT: "#475467",
  25: "#FCFCFD",
  50: "#F9FAFB",
  100: "#F2F4F7",
  200: "#EAECF0",
  300: "#D0D5DD",
  400: "#98A2B3",
  500: "#667085",
  600: "#475467",
  700: "#344054",
  800: "#1D2939",
  900: "#101828",
}

export const GOLD = {
  DEFAULT: "#F4CA56",
}

export const WHITE = {
  DEFAULT: "#fff",
  50: "#F3F4F6",
}

export const PURPLE = {
  DEFAULT: "",
  50: "#5D135F",
}

export const BLUE = {
  DEFAULT: "",
  50: "#113F6F",
}

const tailwindConfig = {
  content: ["./src/**/*.{js,jsx,ts,tsx}", "./node_modules/rtu-components/dist/**/*.{js,jsx}"],
  darkMode: "class",
  theme: {
    extend: {
      animation: {
        "fade-in": "fade-in 0.5s ease-in-out forwards",
      },
      keyframes: {
        "fade-in": {
          "0%": { opacity: "0" },
          "100%": { opacity: "1" },
        },
      },
      fontFamily: {
        grotesk: ["Space Grotesk", "sans-serif"],
        pally: ["Pally", "sans-serif"],
      },
      colors: {
        primary: PRIMARY,
        secondary: SECONDARY,
        stateVisited: STATE_VISITED,
        stateBonus: STATE_BONUS,
        error: ERROR,
        warning: WARNING,
        success: SUCCESS,
        gray: GRAY,
        gold: GOLD,
        white: WHITE,
        purple: PURPLE,
        blue: BLUE,
      },
      width: {
        "100": "25rem",
        "110": "27.5rem",
        "160": "40rem",
        "200": "50rem",
      },
      height: {
        "200": "50rem",
      },
      flex: {
        2: "2 2 0%",
      },
      fontSize: {
        xs: "12px",
        sm: "14px",
        base: "16px",
        lg: "18px",
        xl: "20px",
        "2xl": "24px",
        "3xl": "30px",
        "4xl": "36px",
        "5xl": "48px",
        "6xl": "60px",
        "7xl": "72px",
      },

      spacing: {
        "1": "4px",
        "2": "8px",
        "3": "12px",
        "4": "16px",
        "5": "20px",
        "6": "24px",
        "7": "28px",
        "8": "32px",
        "9": "36px",
        "10": "40px",
      },
      backgroundOpacity: {
        "8": "0.08",
        "16": "0.16",
        "90": "0.90",
        "80": "0.80",
      },
    },
  },
  plugins: [
    require("@headlessui/tailwindcss")({ prefix: "ui" }),
    function ({ addUtilities }) {
      const newUtilities = {
        ".object-contain": {
          "object-fit": "contain",
        },
        ".object-cover": {
          "object-fit": "cover",
        },
      }

      addUtilities(newUtilities, ["responsive", "hover"])
    },
  ],
} as Config

export default tailwindConfig
